<div class="notification-bell" (clickOutside)="closeDropdown()">
  <!-- Bug Report component — hidden but always in DOM so toast subscription stays active -->
  <app-bug-report-button #bugReportBtn class="d-none" (actionTriggered)="closeDropdown()"></app-bug-report-button>

  <!-- Bell Icon Button -->
  <button
    class="btn btn-action-outline btn-bell"
    (click)="toggleDropdown()"
    [class.active]="showDropdown"
    [class.has-notifications]="unreadCount > 0"
    title="Varsler"
  >
    <i class="bi bi-bell-fill"></i>
    <span *ngIf="unreadCount > 0" class="badge-count">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    <span *ngIf="recordingService.recording" class="recording-dot"></span>
  </button>

  <!-- Dropdown -->
  <div class="notification-dropdown" *ngIf="showDropdown">
    <div class="dropdown-header">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="mb-0">
          <i class="bi bi-bell me-2"></i>
          Varsler
          <span *ngIf="unreadCount > 0" class="badge badge-soft-danger ms-2">{{ unreadCount }}</span>
        </h6>
        <div *ngIf="bugReportBtn.isEnabled" class="d-flex align-items-center gap-1">
          <button
            class="btn btn-sm btn-action-outline"
            (click)="bugReportBtn.openBugReport()"
            [disabled]="bugReportBtn.isCapturing"
            [title]="'BugReport.reportBug' | translate"
          >
            <i class="bi bi-bug" *ngIf="!bugReportBtn.isCapturing"></i>
            <span class="spinner-border spinner-border-sm" *ngIf="bugReportBtn.isCapturing"></span>
          </button>
          <button
            class="btn btn-sm btn-action-outline"
            (click)="bugReportBtn.toggleRecording()"
            [class.active]="bugReportBtn.isRecording"
            [title]="(bugReportBtn.isRecording ? 'BugReport.stopRecording' : 'BugReport.startRecording') | translate"
          >
            <i class="bi" [ngClass]="bugReportBtn.isRecording ? 'bi-stop-circle-fill text-danger' : 'bi-record-circle'"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="dropdown-body">
      <!-- Loading -->
      <div *ngIf="loading" class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Laster...</span>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && recentNotifications.length === 0" class="empty-state text-center py-4">
        <i class="bi bi-bell-slash text-muted mb-2" style="font-size: 2rem;"></i>
        <p class="text-muted mb-0">{{ 'Notifications.NoNewNotifications' | translate }}</p>
      </div>

      <!-- Recent Notifications -->
      <div class="notifications-list" *ngIf="!loading && recentNotifications.length > 0">
        <div
          *ngFor="let notification of recentNotifications"
          class="notification-item"
          [class.unread]="!notification.IsRead"
          [class.clickable]="!!notification.NavigationUrl"
          (click)="onNotificationClick(notification)"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1 me-2">
              <div class="notification-subject">
                {{ notification.Subject }}
                <span *ngIf="!notification.IsRead" class="badge badge-soft-primary badge-sm ms-1">Ny</span>
                <i *ngIf="notification.NavigationUrl" class="bi bi-box-arrow-up-right ms-1 text-muted" style="font-size: 0.7rem;"></i>
              </div>
              <div class="notification-body">
                {{ truncate(notification.MessageBody, 60) }}
              </div>
              <div class="notification-time">
                <i class="bi bi-clock me-1"></i>
                {{ formatDateTime(notification.CreatedDate) }}
              </div>
            </div>
            <button
              *ngIf="!notification.IsRead"
              class="btn btn-sm btn-action-outline mark-read-btn"
              (click)="onMarkAsRead(notification, $event)"
              title="Marker som lest"
            >
              <i class="bi bi-check"></i>
              <span class="visually-hidden">Marker som lest</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-footer">
      <button class="btn btn-action-info w-100" (click)="navigateToNotificationCenter()">
        <i class="bi bi-list-ul me-2"></i>
        {{ 'Notifications.ViewAll' | translate }}
      </button>
    </div>
  </div>
</div>
